import Model, { attr } from '@ember-data/model';

import type { TeamMember } from 'webapp-types';
import type { TeamType } from 'webapp/enums/enums';

export default class TeamRecord extends Model {
	@attr('number') ownerId!: number | null;
	@attr('string') name!: string;
	@attr('string') description!: string | null;
	@attr('string') color!: string;
	@attr('number') type!: TeamType;
	@attr('number') order!: number;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	teamMembers!: TeamMember[];
}
